module.exports = __webpack_public_path__ + "img/marker-square.06e5c619.png";